import { createContext } from "react";
const StaticContext = createContext({});
export default StaticContext;
